import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Navigation } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';

export const DayNav = ({ days, firstSlide, theDate, match }) => {
  return (
    <div className="sub-header">
      <div className="tv-schedule__nav-holder">
        {days && days.length > 0 && (
          <Swiper
            // install Swiper modules
            modules={[Navigation]}
            spaceBetween={0}
            slidesPerView={2}
            slidesPerGroup={2}
            initialSlide={firstSlide}
            simulateTouch={false}
            navigation
            breakpoints={{
              400: {
                slidesPerView: 3,
                slidesPerGroup: 3,
              },
              520: {
                slidesPerView: 4,
                slidesPerGroup: 4,
              },
              660: {
                slidesPerView: 5,
                slidesPerGroup: 5,
              },
              980: {
                slidesPerView: 6,
                slidesPerGroup: 6,
              },
              1240: {
                slidesPerView: 7,
                slidesPerGroup: 7,
              },
              1382: {
                slidesPerView: 8,
                slidesPerGroup: 8,
              },
              1526: {
                slidesPerView: 9,
                slidesPerGroup: 9,
              },
              1716: {
                slidesPerView: 10,
                slidesPerGroup: 10,
              },
            }}
          >
            {Object.keys(days).map((key) => (
              <SwiperSlide key={key}>
                <div
                  className={
                    'swiper-slide tv-schedule__nav-link' +
                    (days[key].date_url === theDate
                      ? ' tv-schedule__nav-link--active'
                      : '')
                  }
                >
                  <Link to={`${match.path}/${days[key].date_url}`}>
                    <span className="day">{days[key].day}</span>
                    <span className="date">{days[key].date}</span>
                  </Link>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        )}
      </div>
    </div>
  );
};

DayNav.propTypes = {
  firstSlide: PropTypes.number,
  days: PropTypes.array.isRequired,
  match: PropTypes.object.isRequired,
  theDate: PropTypes.string.isRequired,
};